import { render, staticRenderFns } from "./ExpenseAddModal.vue?vue&type=template&id=23bcbe6e&"
import script from "./ExpenseAddModal.vue?vue&type=script&lang=js&"
export * from "./ExpenseAddModal.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseAddModal.vue?vue&type=style&index=0&id=23bcbe6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports